/**********************************************************
Tree Inventory Form
**********************************************************/
import { TextInput, NumberInput, DatePicker,
  RadioButton, SelectField, Switch, Select } from '../inputs';
import { ISSUE_OR_RECEIVE } from '../../cult_constants';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

const propTypes = {
  formType: PropTypes.string,
  fields: PropTypes.array,
  approvers: PropTypes.array,
  setFormType: PropTypes.func,
  fetchFields: PropTypes.func
};

class TreeInventoryForm extends Component {
  render() {
    return (
      <div>
        <div className="row">
          <div className="col s12 m12 l12 xl12 mt-1">
            <Switch id={'treeInv-formType'} label={'Initialize Inventory'} value={this.props.formType}
              onChange={(e) => this.props.setFormType(e.target.value)}
              switchLabel2={'Create New Inventory Batch'} switchLabel1={'Issue or Receive Inventory'}
            />
          </div>
        </div>
        <form id={this.props.formId} onSubmit={(e) => e.preventDefault()}>
          <div className="row">
            <div className="col s12 m4 l4 xl4">
              <DatePicker id={'treeInv-date'} label={'Date'} min={'2019-01-01'} max={moment().format('YYYY-MM-DD')} required={true} />
            </div>
            <div className="col s12 m4 l4 xl4">
              <label>Location</label>
              <div className="radio-flex">
                <RadioButton id={'treeInv-kau'} name={'treeInv-location'} value={'71'} label={'Kau'} onClick={(e) => this.props.fetchFields(e.target.value)} />
                <RadioButton id={'treeInv-keaau'} name={'treeInv-location'} value={'72'} label={'Keaau'} onClick={(e) => this.props.fetchFields(e.target.value)} />
              </div>
            </div>
            <div className="col s12 m4 l4 xl4">
              <SelectField id={'treeInv-field'} label={'Inventory Field'} opts={this.props.fields.filter((f) => f.field.match(/NK/))} />
            </div>
          </div>
          <div className="row">
            <div className="col s12 m4 l4 xl4">
              <Select id={'treeInv-issuedOrReceived'} label={'Issue or Receivable'} opts={ISSUE_OR_RECEIVE} />
            </div>
            <div className="col s12 m4 l4 xl4">
              <NumberInput id={'treeInv-quantity'} label={'Quantity'} step={"1.0"} min={"0"} />
            </div>
            <div className="col s12 m4 l4 xl4">
              <TextInput id={'treeInv-comments'} label={'Comments'} />
            </div>
          </div>
          <div className="row">
            <div className="col s12 m12 l12 xl12">
              <label>Approver</label>
              <div className="check-flex">
                {
                  this.props.approvers.map((a, i) => (
                    <div key={a.id} className="ml-2">
                      <RadioButton id={`treeInv-approver${i+1}`} name={'treeInv-approver'} label={a.name} value={a.eid} />
                    </div>
                  ))
                }
              </div>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

TreeInventoryForm.propTypes = propTypes;
export default TreeInventoryForm;



/* END */



// WEBPACK FOOTER //
// ./src/cultivation/components/tree_replant/tree_inventory_form.js